import design from '../models/design';
import model from '@99designs/common/apps/ddo/models/designCollection';

export default {
    ...model,
    fromJSON,
};

// Translate from Contests HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        designs: json._embedded.designs.map(design.fromJSON),
        designPageUrls: json._links.designPageUrls
            ? json._links.designPageUrls.map((link) => link.href)
            : [],
        currentPageUrl: json._links.currentPageUrl ? json._links.currentPageUrl.href : undefined,
        designPageOffset: json.designPageOffset || 0,
        totalDesignCount: json.designCount || json._embedded.designs.length,
    };
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/models/design-collection.js